import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const id = (store, key) => {
  try {
    let v = store.getItem(key);
    if (!v) { v = crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`; store.setItem(key, v); }
    return v;
  } catch (e) {
    return "anon";
  }
};

function send(type, path, extra = {}) {
  const q = new URLSearchParams(window.location.search);
  const first = !sessionStorage.getItem("dnn_landed");
  if (type === "view" && first) sessionStorage.setItem("dnn_landed", "1");
  const body = { type, path, vid: id(localStorage, "dnn_vid"), sid: id(sessionStorage, "dnn_sid"), landing: type === "view" && first,
    referrer: first ? document.referrer : "", utm_source: q.get("utm_source") || "", utm_medium: q.get("utm_medium") || "", utm_campaign: q.get("utm_campaign") || "", ...extra };
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { method: "POST", keepalive: true, credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }).catch(() => {});
}

const skip = (path, user) => user?.role === "host" || path.startsWith("/host") || path.startsWith("/print");

export function AnalyticsTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  useEffect(() => {
    if (user === null || skip(pathname, user)) return;
    send("view", pathname);
  }, [pathname, user === null]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest?.("a,button");
      const path = window.location.pathname;
      if (!el || skip(path, user)) return;
      const label = (el.dataset.testid || el.getAttribute("aria-label") || el.textContent || "").trim().slice(0, 120);
      if (label) send("click", path, { label });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [user]);
  return null;
}
